import { EntryTimingGrade } from "protos/portal/metrics";
import { MuiColor } from "common/hooks/useMuiColor";
import { TFunction } from "i18next";

export const ENTRY_TIMING_COLOR: Partial<Record<EntryTimingGrade, MuiColor>> = {
  [EntryTimingGrade.ENTRY_TIMING_GRADE_IDEAL]: "success",
  [EntryTimingGrade.ENTRY_TIMING_GRADE_ACCEPTABLE]: "warning",
  [EntryTimingGrade.ENTRY_TIMING_GRADE_LATE]: "error",
};

/**
 * @returns the display text for a grade, or undefined for unspecified and
 * unrecognized grades, which callers render as blank.
 **/
export const entryTimingGradeLabel = (
  t: TFunction,
  grade: number | undefined
): string | undefined => {
  switch (grade) {
    case EntryTimingGrade.ENTRY_TIMING_GRADE_IDEAL: {
      return t("components.EntryTimingGrade.ideal");
    }
    case EntryTimingGrade.ENTRY_TIMING_GRADE_ACCEPTABLE: {
      return t("components.EntryTimingGrade.acceptable");
    }
    case EntryTimingGrade.ENTRY_TIMING_GRADE_LATE: {
      return t("components.EntryTimingGrade.late");
    }
    default: {
      return undefined;
    }
  }
};
